import React, { useState } from 'react';
import Hero from '../components/Hero';
import Stats from '../components/Stats';
import Services from '../components/Services';
import Reviews from '../components/Reviews';
import JoinSteps from '../components/JoinSteps';
import FAQ from '../components/FAQ';
import AuthModal from '../components/AuthModal';

export default function Home() {
  const [isRegisterOpen, setIsRegisterOpen] = useState(false);

  return (
    <>
      <Hero onOpenRegister={() => setIsRegisterOpen(true)} />
      <Stats />
      <Services onOpenRegister={() => setIsRegisterOpen(true)} />
      <Reviews />
      <JoinSteps onOpenRegister={() => setIsRegisterOpen(true)} />
      <FAQ onOpenRegister={() => setIsRegisterOpen(true)} />
      <AuthModal
        isOpen={isRegisterOpen}
        onClose={() => setIsRegisterOpen(false)}
        type="register"
      />
    </>
  );
}